import React, {useEffect, useState} from "react";
import TextInput from "../../../components/TextInput";
import avatar from "../../../../assets/img/noAvatar.png";
import CustomPagination from "../../../components/CustomPagination";
import Dropdown from "../../../components/Dropdown";
import { useNavigate, useLocation } from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {getListAction, setActionSelected, setLoadingSearchAction, setCurrentPage, setGlobalConditionSearch} from "reducers/action";
import { setJobDetailDataTemp, setJobDetailData } from "reducers/companyJob";
import {ThunkDispatch} from "@reduxjs/toolkit";
import {formatDateTime, formatName, trimStringFields} from "utils/format";
import CustomIconButton from "../../../components/CustomIconButton";
import {LoadingIcon} from "components/Icons";

export const initActionTableHeaders = [
  { title: "", isSortable: false, currentSortState: 0, width: "w-[2.25rem]", },
  { title: (
      <>
        アクシ<br />ョン
      </>
    ), field: "type__label", isSortable: true, currentSortState: 0, width: "min-w-[5rem] max-w-[8rem]", },
  { title: "タレント", field: "talent__last_name", isSortable: true, currentSortState: 0, width: "min-w-[9rem] max-w-[11rem]", },
  { title: "更新日時", field: "action_detail_action__created_at", isSortable: true, currentSortState: 1, width: "w-auto min-w-[8rem] max-w-[11rem]" },
  { title: "ステータス", field: "action_detail_action__status__label", isSortable: true, currentSortState: 0, width: "w-[8rem]" },
  { title: "担当者", field: "action_detail_action__staff__last_name", isSortable: true, currentSortState: 0, width: "min-w-[7rem] max-w-[9rem]" },
  { title: "求人名", field: "job__title", currentSortState: 0, width: "min-w-[12rem]" },
  { title: "職種", isSortable: false, currentSortState: 0, width: "min-w-[8rem] max-w-[9rem]"},
];

const sortingStates = ["default", "desc", "asc"];

const ActionList = () => {
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  const { pageSize, currentPage, actionList, optionsRelatedAction, loadingSearchAction, globalConditionSearch } = useSelector((state: any) => state.action);
  const navigate = useNavigate();
  const [searchTalentQuery, setSearchTalentQuery] = useState("");
  const [searchStaffQuery, setSearchStaffQuery] = useState("");
  const [searchJobQuery, setSearchJobQuery] = useState("");
  const [actionStatus, setActionStatus] = useState(null);
  const [sortBy, setSortBy] = useState("");
  const [actionTableHeaders, setInitActionTableHeaders] = useState(initActionTableHeaders);

  const handeSetSearchTalentQuery = (value: any) => {
    setSearchTalentQuery(value);
    dispatch(setCurrentPage(1));
    const globalCondition = {
      ...globalConditionSearch,
      searchTalentQuery: value,
    };
    dispatch(setGlobalConditionSearch(globalCondition));
    submitSearchAction(1, actionStatus, value, searchJobQuery, searchStaffQuery);
  };
  const handeSetSearchStaffQuery = (value: any) => {
    setSearchStaffQuery(value);
    dispatch(setCurrentPage(1));
    const globalCondition = {
      ...globalConditionSearch,
      searchStaffQuery: value,
    };
    dispatch(setGlobalConditionSearch(globalCondition));
    submitSearchAction(1, actionStatus, searchTalentQuery, searchJobQuery, value);
  };
  const handeSetSearchJobQuery = (value: any) => {
    setSearchJobQuery(value);
    dispatch(setCurrentPage(1));
    const globalCondition = {
      ...globalConditionSearch,
      searchJobQuery: value,
    };
    dispatch(setGlobalConditionSearch(globalCondition));
    submitSearchAction(1, actionStatus, searchTalentQuery, value, searchStaffQuery);
  };
  const handeSearchAction = (event: any) => {
    if (event.key === "Enter") {
      dispatch(setCurrentPage(1));
      submitSearchAction(1, actionStatus, searchTalentQuery, searchJobQuery, searchStaffQuery);
    }
  };

  const handleChangeActionStatus = (value: any) => {
    setActionStatus(value);
    dispatch(setCurrentPage(1));
    const globalCondition = {
      ...globalConditionSearch,
      actionStatus: value,
    };
    dispatch(setGlobalConditionSearch(globalCondition));
    submitSearchAction(1, value, searchTalentQuery, searchJobQuery, searchStaffQuery);
  };

  const handleChangePage = (page: number) => {
    dispatch(setCurrentPage(page));
    submitSearchAction(page, actionStatus, searchTalentQuery, searchJobQuery, searchStaffQuery);
  };

  const handleSort = (index: any) => {
    const newHeaders = actionTableHeaders.map((header, idx) =>
      index === idx
        ? {
            ...header,
            currentSortState:
              (header.currentSortState + 1) % sortingStates.length,
          }
        : { ...header, currentSortState: 0 }
    );
    setInitActionTableHeaders(newHeaders);

    let newSortBy = "";
    for (let item of newHeaders) {
      if(item.currentSortState != 0) {
        let refix_str = item.currentSortState == 1 ? "-" : "";
        newSortBy += refix_str + item.field + ",";
      }
    }
    const globalCondition = {
      ...globalConditionSearch,
      sortBy: newSortBy,
    };
    dispatch(setGlobalConditionSearch(globalCondition));
    setSortBy(newSortBy);
  };

  const submitSearchAction = (page: number, status: any, searchTalentText: any, searchJobText: any, searchStaffText: any) => {
    let data = { searchTalent: searchTalentText, searchStaff: searchStaffText,
        searchJob: searchJobText, status: status?.id ? status?.id: null, sortBy: sortBy, page: page, pageSize: pageSize };
    dispatch(setLoadingSearchAction(true));

    data = trimStringFields(data);
    dispatch(getListAction(data));
  };

  const selectAction = (action: any ) => {
    dispatch(setActionSelected(action));
    navigate("/company/action/edit/" + action.id);
  };

  const goToJobDetail = (jobID: any ) => {
    dispatch(setJobDetailDataTemp(null));
    dispatch(setJobDetailData([]));
    navigate("/company/job/detail/" + jobID, { state: { isFromDetail: true } });
  };

  useEffect(() => {
    // Get list actions
    let page = 1;
    if(sessionStorage.getItem('isResetPageActionList') != 'true') {
      sessionStorage.removeItem('isResetPageActionList')
      page = currentPage;

      setSearchTalentQuery(globalConditionSearch.searchTalentQuery);
      setSearchStaffQuery(globalConditionSearch.searchStaffQuery);
      setSearchJobQuery(globalConditionSearch.searchJobQuery);
      setActionStatus(globalConditionSearch.actionStatus);
      setSortBy(globalConditionSearch.sortBy);

      submitSearchAction(page, globalConditionSearch.actionStatus, globalConditionSearch.searchTalentQuery, globalConditionSearch.searchJobQuery, globalConditionSearch.searchStaffQuery);
    } else {
      sessionStorage.removeItem('isResetPageActionList')
      dispatch(setCurrentPage(1));
      dispatch(setGlobalConditionSearch({
        searchTalentQuery: "",
        searchStaffQuery: "",
        searchJobQuery: "",
        actionStatus: null,
        sortBy: ""
      }));
      submitSearchAction(page, actionStatus, searchTalentQuery, searchJobQuery, searchStaffQuery);
    }
  }, [sortBy]);

  return (
    <>
      <div className="rounded-t-lg px-4 py-2 bg-[#E9E9E9] flex items-center gap-6">
        <div className="flex items-center gap-2 flex-1">
          <p className="text-xs alu-text-base-1 shrink-0">タレント</p>
          <div className="max-w-11rem">
            <TextInput
              customClassName="pl-[2rem]"
              id="searchTalentQuery"
              name="searchTalentQuery"
              value={searchTalentQuery}
              onChange={(e: any) => handeSetSearchTalentQuery(e.target.value)}
              onClearQuery={() => handeSetSearchTalentQuery("")}
              onKeyDown={(e: any) => handeSearchAction(e)}
              placeholder="検索"
              searchIcon={true}
              size="filter"
            />
          </div>
        </div>
        <div className="flex items-center gap-2 flex-1">
          <p className="text-xs alu-text-base-1 shrink-0">担当者</p>
          <div className="max-w-[11rem]">
            <TextInput
              customClassName="pl-[2rem]"
              id="searchStaffQuery"
              name="searchStaffQuery"
              value={searchStaffQuery}
              onChange={(e: any) => handeSetSearchStaffQuery(e.target.value)}
              onClearQuery={() => handeSetSearchStaffQuery("")}
              onKeyDown={(e: any) => handeSearchAction(e)}
              placeholder="検索"
              searchIcon={true}
              size="filter"
            />
          </div>
        </div>
        <div className="flex items-center gap-2 flex-1">
          <p className="text-xs alu-text-base-1 shrink-0">求人</p>
          <div className="max-w-[14rem]">
            <TextInput
              customClassName="pl-[2rem]"
              id="searchJobQuery"
              name="searchJobQuery"
              value={searchJobQuery}
              onChange={(e: any) => handeSetSearchJobQuery(e.target.value)}
              onClearQuery={() => handeSetSearchJobQuery("")}
              onKeyDown={(e: any) => handeSearchAction(e)}
              placeholder="検索"
              searchIcon={true}
              size="filter"
            />
          </div>
        </div>
        <div className="flex items-center gap-2 flex-1">
          <p className="text-xs alu-text-base-1 shrink-0">ステータス</p>
          <div className="min-w-[11rem]">
            <Dropdown
              clearable={true}
              inputWidth="full"
              options={optionsRelatedAction?.action_status}
              value={actionStatus}
              onChange={(value: any) => handleChangeActionStatus(value)}
              placeholder="選択してください"
              size="filter"
            />
          </div>
        </div>
      </div>
      <div className="bg-white rounded-b-lg">
        <table className="table-auto w-full">
          <thead className="border-b alu-border px-4 py-2">
            <tr>
              {actionTableHeaders.map((header, index) => (
                <th key={index} className={`px-2 py-2 text-left ${header.width}`}>
                  <div className="flex items-center"
                    onClick={() => header.isSortable && handleSort(index)} >
                    <p
                      className={`shrink-0 ${
                        header.currentSortState !== 0
                          ? "font-bold underline underline-offset-4 alu-text-base-2"
                          : "font-normal alu-text-base-1"
                      } ${
                        header.isSortable ? "hover:cursor-pointer" : ""
                      } text-sm leading-[1.3125]`}
                    >
                      {header.title}
                    </p>
                    {header.isSortable && (
                      <button
                        className={`${
                          header.currentSortState === 2
                            ? "rotate-180"
                            : "rotate-0"
                        }`}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <g clipPath="url(#clip0_8574_176)">
                            <path d="M7 10L12 15L17 10H7Z" fill="#808080" />
                          </g>
                          <defs>
                            <clipPath id="clip0_8574_176">
                              <rect width="24" height="24" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      </button>
                    )}
                  </div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {actionList?.results?.map((action: any, idx: any) => (
              <tr key={idx} className="hover:bg-[#fff3e5] border-t border-t-[#E0E0E0] cursor-pointer" onClick={() => selectAction(action)}>
                <td className="px-2 py-2 text-center w-[2.25rem]">
                  <div className="flex items-center justify-center">
                    <CustomIconButton
                      variant="icononly"
                      size="sm"
                      onClick={() => selectAction(action)}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <g clipPath="url(#clip0_16829_5202)">
                          <path
                            d="M10.5 16.5L15.5 11.5L10.5 6.5L10.5 16.5Z"
                            fill="currentColor"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_16829_5202">
                            <rect width="24" height="24" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    </CustomIconButton>
                  </div>
                </td>
                <td className="px-2 py-2 text-left font-normal text-sm leading-[1.3125] alu-text-base-2 min-w-[5rem] max-w-[8rem]">
                  {action.type?.label}
                </td>
                <td className="px-2 py-2 text-left font-normal text-sm leading-[1.3125] alu-text-base-2 min-w-[9rem] max-w-[11rem]">
                  <div className="flex items-center gap-2">
                    <img
                      src={action.talent?.avatar ? action.talent?.avatar : avatar}
                      alt="avt"
                      className="w-8 h-8 rounded-full object-cover"
                    />
                    <p className="text-sm alu-text-base-2">
                      {formatName(action.talent?.first_name, action.talent?.last_name)}
                      {!action?.is_active ? "（退会済み）" : ""}
                    </p>
                  </div>
                </td>
                <td className="px-2 py-2 text-left font-normal text-sm leading-[1.3125] alu-text-base-2 w-auto min-w-[8rem] max-w-[11rem]">
                  {formatDateTime(action?.created_at)}
                </td>
                <td className="px-2 py-2 text-left font-normal text-sm leading-[1.3125] alu-text-base-2 w-[8rem]">
                  <span className="py-[0.125rem] px-2 rounded-2xl bg-[#E0E0E0] alu-text-base-2">
                    {action?.is_active ? action.status_str : '退会済み'}
                  </span>
                </td>
                <td className="px-2 py-2 text-left font-normal text-sm leading-[1.3125] alu-text-base-2 min-w-[7rem] max-w-[9rem]">
                  {formatName(action.main_staff?.first_name, action.main_staff?.last_name)}
                </td>
                <td className="px-2 py-2 text-left font-normal text-sm leading-[1.3125] alu-text-base-2 min-w-[12rem]">
                  <p className="max-w-fit line-clamp-1 underline underline-offset-2 hover:text-[#FF861A] hover:cursor-pointer" 
                    onClick={(e) => {
                      goToJobDetail(action?.job?.id); 
                      e.stopPropagation();}}>
                      {action.job?.title}
                  </p>
                </td>
                <td className="px-2 py-2 text-left font-normal text-sm leading-[1.3125] alu-text-base-2 min-w-[8rem] max-w-[9rem]">
                  {action.job?.occupation_1?.name}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {loadingSearchAction && (
          <div className="flex items-center justify-center"><LoadingIcon/></div>
        )}
      </div>
      {actionList?.count && actionList?.count > pageSize ?
      <div className="flex items-center justify-center mt-6">
        <CustomPagination
          total={actionList?.count}
          currentPage={currentPage}
          pageSize={pageSize}
          onPageChange={handleChangePage}
        />
      </div>
      : ""}
    </>
  );
};

export default ActionList;
